module.exports = __webpack_public_path__ + "static/media/Location.3fc17d37.svg";